/**
 * 課題の識別子。課題は 7 つで固定運用のため、課題名は自由入力せずこのキーで管理する。
 * server の AyumiTopicKey と一致させること
 */
export enum AyumiTopicKey {
  ASSET_MANAGEMENT = 'assetManagement',
  WORK_AND_CARE = 'workAndCare',
  LIFE_CHANGE = 'lifeChange',
  MEDICAL = 'medical',
  MOBILITY = 'mobility',
  ISOLATION = 'isolation',
  UNDERSTANDING = 'understanding',
}

/** 表示名。正はサーバの AYUMI_TOPIC_LABELS で、ここはプルダウンのフォールバック表示用 */
export const AYUMI_TOPIC_KEY_LABELS: Record<AyumiTopicKey, string> = {
  [AyumiTopicKey.ASSET_MANAGEMENT]: '資産管理',
  [AyumiTopicKey.WORK_AND_CARE]: '仕事と介護',
  [AyumiTopicKey.LIFE_CHANGE]: '暮らしの変化',
  [AyumiTopicKey.MEDICAL]: '受診・医療',
  [AyumiTopicKey.MOBILITY]: '移動と運転',
  [AyumiTopicKey.ISOLATION]: '孤立を防ぐ',
  [AyumiTopicKey.UNDERSTANDING]: '正しい理解',
};

/** 課題の公開ステータス。server の AyumiTopicStatus と一致させること */
export enum AyumiTopicStatus {
  DRAFT = 0,
  PUBLIC = 1,
  HIDDEN = 2,
}

export const AYUMI_TOPIC_STATUS_LABELS: Record<AyumiTopicStatus, string> = {
  [AyumiTopicStatus.DRAFT]: '下書き',
  [AyumiTopicStatus.PUBLIC]: '公開中',
  [AyumiTopicStatus.HIDDEN]: '非表示',
};

/** セルフチェックの回答ボタンラベルセット。server の AyumiAnswerLabelSet と一致させること */
export enum AyumiAnswerLabelSet {
  TALK = 1,
  KNOW = 2,
  DONE = 3,
}

/** 実際にアプリへ出る文言はサーバが解決する。ここは管理画面のプルダウン表示用 */
export const AYUMI_ANSWER_LABEL_SET_OPTIONS = [
  {
    value: AyumiAnswerLabelSet.TALK,
    label: '話せている・だいたい・話せてない',
  },
  {
    value: AyumiAnswerLabelSet.KNOW,
    label: '知っている・なんとなく・知らない',
  },
  {
    value: AyumiAnswerLabelSet.DONE,
    label: 'できている・だいたい・できていない',
  },
];

/** 優先度・影響度・頻度。server の AyumiLevel と一致させること */
export enum AyumiLevel {
  LOW = 1,
  MIDDLE = 2,
  HIGH = 3,
}

/** 優先度は 高/中/低 表記 */
export const AYUMI_PRIORITY_OPTIONS = [
  { value: AyumiLevel.HIGH, label: '高' },
  { value: AyumiLevel.MIDDLE, label: '中' },
  { value: AyumiLevel.LOW, label: '低' },
];

/** 影響度・頻度は 大/中/小 表記（アプリの表記と揃える） */
export const AYUMI_SCALE_OPTIONS = [
  { value: AyumiLevel.HIGH, label: '大' },
  { value: AyumiLevel.MIDDLE, label: '中' },
  { value: AyumiLevel.LOW, label: '小' },
];

/** 対策項目のサービス区分。server の AyumiServiceType と一致させること */
export enum AyumiServiceType {
  PUBLIC_SERVICE = 1,
  PRIVATE_SERVICE = 2,
  HOUSEHOLD = 3,
}

export const AYUMI_SERVICE_TYPE_LABELS: Record<AyumiServiceType, string> = {
  [AyumiServiceType.PUBLIC_SERVICE]: '公的サービス・制度',
  [AyumiServiceType.PRIVATE_SERVICE]: '民間サービス',
  [AyumiServiceType.HOUSEHOLD]: '家庭内',
};

/** 「そなえる」タブでセクションを並べる順序 */
export const AYUMI_SERVICE_TYPE_ORDER: AyumiServiceType[] = [
  AyumiServiceType.PUBLIC_SERVICE,
  AyumiServiceType.PRIVATE_SERVICE,
  AyumiServiceType.HOUSEHOLD,
];

/** 紐づけるオファーの入力欄を出す区分。DB は全区分で持てるが UI は民間サービスのみ */
export const AYUMI_SERVICE_TYPES_WITH_OFFER: AyumiServiceType[] = [
  AyumiServiceType.PRIVATE_SERVICE,
];
